import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext } from 'react';
import UserGoBack from "../../user/UserGoBack";
import ArticleUtile from "../ArticleUtile";
import RightPartContent from "../RightPartContent";
import { useTopic } from "../../../hooks/useTopic";

const HelpTopicProtectionInfos = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { topic, isLoading, LoadingComponent } = useTopic();
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Votre compte', link: '/topics/compte'},
    { label: 'Sécurité du compte', link: '/topics/compte/securite'},
    { label: topic.title, link: topic.link},
  ]

  // <a target='_blank' className="link" href="/account-settings">Compte,</a>

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-32">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              La protection de vos données personnelles est importante. Si vous fermez votre compte Wodzone, nous supprimerons vos données personnelles 
              comme indiqué dans notre<a target='_blank' className="link" href="/topics/about/62">Politique de confidentialité</a>et nos<a target='_blank' className="link" href="#">Conditions de service.</a>
            </p>
            <p className="help-text">
              En vertu de la loi, nous pouvons être amenés à conserver certaines informations vous concernant plus longtemps. 
              Il s'agit notamment des informations relatives aux transactions de paiement, à la détection de fraude, à la sécurité ou au respect des obligations de conformité.
            </p>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicProtectionInfos